import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "./unwrapApiResponse";

export async function listPages() {
  const response = await axiosClient.get("/api/admin/pages");
  return unwrapApiResponse(response);
}

export async function getPage(id) {
  const response = await axiosClient.get(`/api/admin/pages/${id}`);
  return unwrapApiResponse(response);
}

export async function createPage(payload) {
  const response = await axiosClient.post("/api/admin/pages", payload);
  return unwrapApiResponse(response);
}

export async function updatePage(id, payload) {
  const response = await axiosClient.put(`/api/admin/pages/${id}`, payload);
  return unwrapApiResponse(response);
}

export async function deletePage(id) {
  const response = await axiosClient.delete(`/api/admin/pages/${id}`);
  return unwrapApiResponse(response);
}
